import React, { Component } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { searchBooks } from "./functions/gbooks";
import { h, addBook } from "./functions/books";

import "./SelectFavoriteBook.css";
import "./AvailableBooks.css";

import Book from "./Book";
import Loading from "./Loading";

class SelectFavoriteBook extends Component {
  constructor(props) {
    super(props);

    this.state = {bookQuery: "", loading: false};

    onAuthStateChanged(getAuth(), (user) =>
      (user) ? h(user.uid).then((a) => (a) ? this.setState({add: true}) : null) : null
    );
  }

  handleBook = (e) => {
    this.setState({bookQuery: e.target.value});
  }

  searchBook = (e) => {
    if ((e.type === "click" || (e.type === "keyup" && e.keyCode === 13)) &&
        this.state.bookQuery.length > 1)
    {
      this.props.clearBook();
      this.setState({loading: true});

      searchBooks(this.state.bookQuery, (books) => {
        this.setState({books, loading: false});
      });
    }
  }

  setBook = (book) => {
    this.props.setBook(book);
    this.setState({books: undefined});
  }

  bookResult = () => {
    if (this.state.loading) {
      return <Loading />;

    } else if (this.state.books) {
      return (
        <div className="AvailableBooks">
          {this.state.books.map((book) =>
            <div key={book.id} className="AvailableBook Column Center">
              <div className="Pointer" onClick={() => this.setBook(book)}>
                <Book book={book} />
              </div>
              {(this.state.add) ? <div className="Button Continue" onClick={() => addBook(book)}>Add to Library</div> : ""}
            </div>
          )}
        </div>
      );
    } else if (this.state.book === null) {
      return (
        <div>Book not found! Try searching again.</div>
      );
    }

    return <div />;
  }

  render() {
    return (
      <div className="Column Center">
        <div className="BookSearch">
          <input className="SearchBox" type="text" placeholder="What's your favorite book?" value={this.state.bookQuery} onChange={this.handleBook} onKeyUp={this.searchBook} />
          <div className="SearchButton" onClick={this.searchBook}><img className="SearchIcon" src="/foreword/images/right-arrow.png" alt="Search" /></div>
        </div>

        {this.bookResult()}
      </div>
    );
  }
}

export default SelectFavoriteBook;
